module.exports = __webpack_public_path__ + "img/profile-remove.4bec5621.svg";